import { X } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { SearchFilters } from '@/utils/optimizedQueries';

interface FilterChip {
  key: keyof SearchFilters;
  label: string;
  value: any;
}

interface FilterChipsProps {
  activeFilters: FilterChip[];
  onRemoveFilter: (filterKey: keyof SearchFilters) => void;
  onClearAll: () => void;
}

export const FilterChips = ({ activeFilters, onRemoveFilter, onClearAll }: FilterChipsProps) => {
  if (activeFilters.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-2 mb-4">
      <span className="text-sm text-muted-foreground">Active filters:</span>
      {activeFilters.map((filter) => (
        <Badge 
          key={filter.key} 
          variant="secondary" 
          className="flex items-center gap-1 px-3 py-1 text-sm cursor-pointer hover:bg-destructive hover:text-destructive-foreground transition-colors"
          onClick={() => onRemoveFilter(filter.key)}
        >
          {filter.label}
          <X className="h-3 w-3" />
        </Badge>
      ))}
      {activeFilters.length > 1 && (
        <button
          onClick={onClearAll}
          className="text-sm text-primary hover:text-primary/80 font-medium transition-colors"
        >
          Clear all
        </button>
      )}
    </div>
  );
};